import { captureResponseStartedOnce } from '@/shared-measurement';
import type { ResponderGateway } from '@/shared-responder-v2-core';

import type { FunnelAnalyticsArgs } from './survey-responder-v2-adapter-funnel.types';

export function withResponderFunnelAnalytics(
  gateway: ResponderGateway,
  { posthog, projectId, isFunnelTracked }: FunnelAnalyticsArgs
): ResponderGateway {
  if (!isFunnelTracked || !projectId) return gateway;

  return {
    ...gateway,
    async addQuestionMessage(input) {
      const result = await gateway.addQuestionMessage(input);

      captureResponseStartedOnce(posthog, {
        projectId,
        responseId: input.insightId,
      });

      return result;
    },
  };
}
